import React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Backdrop from "@mui/material/Backdrop";
import PropTypes from "prop-types";
import ReportsCarousel from "./ReportsCarousel.js";
import ReportsTable from "./ReportsTable.js";
import AADHeader from "./components/AADHeader.js";
export default function StandardsFrameworks() {
  const username = localStorage.getItem("userName");
  var myHeaders = new Headers();
  myHeaders.append("username", username);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const [isOpen, setIsOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  const getOpen = (open) => {
    setIsOpen(open);
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem('loginType');
    if (loginType === 'AAD') {
      return <AADHeader />;
    }
    return <LoginHeader heading="" />;
  };

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      <div id="sidebar-wrapper" className={isOpen ? "sidebar-open" : "sidebar-close"}>
        <SideNavigation getOpen={getOpen} />
      </div>
      <div id="page-content-wrapper" className={isOpen ? "" : "page-content-wrapper-pd-0"}>
      {renderHeader()}
        <div className="container formpd">
          <div className="flex justify-content-between">
            <div className="steps__containt-hader">
              <h3 className="title">Standards & Frameworks</h3>
              <div role="presentation">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" href="/standards">
                    Reports
                  </Link>
                  <Typography color="text.primary">Standards & Frameworks</Typography>
                </Breadcrumbs>
              </div>
            </div>
          </div>
          <div className="col-md-12 flex pd-0">
            <h6>Start a new report with built-in frameworks</h6>
          </div>
          <div>
            <ReportsCarousel />
          </div>
          <div className="col-md-12 flex pd-0 pt-10">
            <h6>Existing Reports</h6>
          </div>
          {/* <ReportsTable /> */}
        </div>
      </div>
    </div>
  );
}
